import Dropdown, { DEPRECATED_COLOR_VARIANT } from "./Dropdown";
export { Dropdown, DEPRECATED_COLOR_VARIANT };
export default Dropdown;
